import {  stoves } from '../config.js'

const initialState = {
    stove: stoves[0].id,
    stoveDescription:""
}



const stove = (state = initialState, action) => {

    switch (action.type) {
        case 'STOVE_CHANGED':
            return Object.assign({}, state, {
                stove: action.stove
            })
        case 'STOVE_DESCRIPTION_CHANGED':
            return Object.assign({}, state, {
                stoveDescription: action.description
            })

        default:
            return state;
    }
}
export default stove;